import React from "react";
import { useTranslation } from "react-i18next";

export default function PopoverContent() {
  const { t } = useTranslation();

  const items = [
    {
      title: t('components.coreAudiencesForm.examples.startupFounders.title'),
      description: t('components.coreAudiencesForm.examples.startupFounders.description'),
      username: 'Aha'
    },
    {
      title: t('components.coreAudiencesForm.examples.enterprises.title'),
      description: t('components.coreAudiencesForm.examples.enterprises.description'),
      username: 'Aha'
    },
    {
      title: t('components.coreAudiencesForm.examples.agencies.title'),
      description: t('components.coreAudiencesForm.examples.agencies.description'),
      username: 'Aha'
    }
  ];

  const Item = (item: {
    title: string;
    description: string;
    username: string;
    index: number;
  }) => {
    return (
      <div className={`self-stretch inline-flex flex-col justify-start items-start gap-2 border-b border-borderColor pb-4 ${item?.index === items.length - 1 ? 'border-b-0 pb-0' : ''}`}>
        <div className="self-stretch inline-flex justify-between items-center">
          <div className="justify-start text-text-color-primary text-sm font-medium font-['DM_Sans'] leading-snug">
            {item?.title}
          </div>
          <div className="justify-start text-font&icon-placeholder text-xs font-medium font-['DM_Sans'] leading-none">
            @{item?.username}
          </div>
        </div>
        <div className="self-stretch justify-start text-font&icon-secondary text-sm font-normal font-['DM_Sans'] leading-snug">
          {item?.description}
        </div>
      </div>
    );
  };

  return <div className="w-[838px] p-2 flex flex-col gap-4">
    {items.map((item, index) => (
      <Item key={index} {...item} index={index} />
    ))}
  </div>;
}
